// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pw-1";
export var stateContainer = "_pw-0";